import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Row } from 'components/common/Layout/Row';
import { SCOPES } from 'constants/permissions';
import { useRole } from 'hooks';
import useGroups from 'hooks/useGroups';
import hasPermission from 'utils/hasPermission';

import { StyledSelect } from './styles';

const FormFields = () => {
  const intl = useIntl();
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const { permissions } = useRole();
  const { groupOptions } = useGroups();

  return (
    <>
      <Row gap="1.2rem">
        <Controller
          name="role"
          control={control}
          rules={{
            validate: (value, formValues) =>
              !!value || !!formValues.role || intl.formatMessage({ id: 'role.presence' })
          }}
          render={({ field }) => (
            <StyledSelect
              {...field}
              id="role"
              label={intl.formatMessage({ id: 'settings.addRole.form.role' })}
              options={groupOptions}
              isSearchable
              enablePortal
              isDisabled={!hasPermission(permissions, [SCOPES.createProjects])}
              variant="new"
              withoutHighlight
              placeholder={intl.formatMessage({ id: 'assignment.form.role.placeholder' })}
              errors={errors.role?.message}
            />
          )}
        />
      </Row>
    </>
  );
};

export default FormFields;
